import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_movimento_comercial = _resolveComponent("selecionar-tipo-movimento-comercial")!
  const _component_selecionar_cenario_fiscal = _resolveComponent("selecionar-cenario-fiscal")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_selecionar_tipo_frete = _resolveComponent("selecionar-tipo-frete")!
  const _component_selecionar_tabela_preco = _resolveComponent("selecionar-tabela-preco")!
  const _component_selecionar_tipo_preco = _resolveComponent("selecionar-tipo-preco")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    center: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Cadastro de Tipos de Operação")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir) || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar(true)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(false)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.telaBase.empresasDisponiveis.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresas",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            varias: true,
                            empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                            codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                            "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                          }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.tipoOperacao.descricao) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.tipoOperacao.descricao]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipos de Movimentação",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_movimento_comercial, {
                        varios: true,
                        valoresSelecionados: _ctx.state.tiposMovimentos,
                        "onUpdate:valoresSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.tiposMovimentos) = $event))
                      }, null, 8, ["valoresSelecionados"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_form_item, {
                    label: "Cenário Fiscal",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_cenario_fiscal, {
                        codigoSelecionado: _ctx.state.tipoOperacao.codigoCenarioFiscal,
                        "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.tipoOperacao.codigoCenarioFiscal) = $event)),
                        empresas: _ctx.telaBase.empresasSelecionadas
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_form_item, {
                    label: "Forma de Pagamento",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_forma_pagamento, {
                        empresas: _ctx.telaBase.empresasSelecionadas,
                        "codigo-selecionado": _ctx.state.tipoOperacao.codigoFormaPagamento,
                        "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.tipoOperacao.codigoFormaPagamento) = $event))
                      }, null, 8, ["empresas", "codigo-selecionado"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Frete",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_frete, {
                        valor: _ctx.state.tipoOperacao.tipoFrete,
                        "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.tipoOperacao.tipoFrete) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, {
                    label: "Tabela de Preço",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tabela_preco, {
                        codigoSelecionado: _ctx.state.tipoOperacao.codigoTabelaPreco,
                        "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.tipoOperacao.codigoTabelaPreco) = $event)),
                        empresas: _ctx.telaBase.empresasSelecionadas
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Preço",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_preco, {
                        codigoSelecionado: _ctx.state.tipoOperacao.codigoTipoPreco,
                        "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.tipoOperacao.codigoTipoPreco) = $event)),
                        empresas: _ctx.telaBase.empresasSelecionadas
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Movimentar Estoque",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_sim_nao, {
                        radioButton: true,
                        valor: _ctx.state.tipoOperacao.movimentarEstoque,
                        "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.tipoOperacao.movimentarEstoque) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_form_item, {
                    label: "Gerar Comissão",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_sim_nao, {
                        radioButton: true,
                        valor: _ctx.state.tipoOperacao.gerarComissao,
                        "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.tipoOperacao.gerarComissao) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_a_form_item, {
                    label: "Padrão Frente Caixa",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_sim_nao, {
                        radioButton: true,
                        valor: _ctx.state.tipoOperacao.padraoFrenteCaixa,
                        "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.tipoOperacao.padraoFrenteCaixa) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}